import { Component, Input, OnInit, Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {
  @Input() total: any;
  @Input() pageSize: any;
  @Input() page: any;
  @Output('page') emitPage = new EventEmitter<number>();
  totalPage : any;
  constructor() {}
  ngOnInit(): void {

  }
  ngOnChanges() {
     this.totalPage = Math.floor((this.total - 1) / this.pageSize + 1); 
  }
  previousPage() {
    this.page = this.page -1;
    this.emitPage.emit(this.page);
  }
  nextPage() {
    this.page = this.page + 1;
    this.emitPage.emit(this.page);
  }


}